import React from 'react';


// @mui
import { TableCell, Typography } from '@mui/material';


export default class GridMultipleItemsCell extends React.Component {
    render() {
        const baseStyle = this.props.styles;
        return (
            <TableCell key={this.props.field.id} align="left" sx={{ ...baseStyle }}>
                {this.props.row[this.props.field.id] && this.props.row[this.props.field.id].length > 0 ?
                    this.props.row[this.props.field.id].map((item, index) => {
                        return (
                            <Typography key={index} variant="body2" component="p">
                                {item.name}
                            </Typography>
                        );
                    })
                    :
                    null
                }
            </TableCell>
        );
    }
}
